module.exports = __webpack_public_path__ + "static/franklin-package-4db73f1081c899875bae60dd4e949288.png";